<template>
  <section v-if="show" class="container">
    <el-card class="filter-by-prices">
      <el-row v-for="(stats, field) in byPrices" :key="field" class="row-item">
        <el-col :span="4">Фильтр цен {{ priceFilterTitle[field] }}:</el-col>
        <el-col :span="20">
          <el-checkbox-group v-model="_self[`${field}Filter`]">
            <el-row type="flex" align="middle" class="fw-wrap">
              <el-checkbox
                v-for="(statByPrice, index) in stats"
                :key="index"
                :label="statByPrice.price"
                :value="statByPrice.price"
              >
                {{ labelCheckbox(statByPrice) }}
              </el-checkbox>
            </el-row>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </el-card>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { priceFilterTitle } from '@/views/LoadDay/Components/constants'

export default {
  name: 'FilterByPrice',
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      priceFilterTitle,
    }
  },
  computed: {
    ...mapGetters('loadDay', ['getStats']),
    byPrices() {
      return this.getStats('by_prices')
    },
    show() {
      return this.byPrices?.field?.length || this.byPrices?.storage?.length
    },
    fieldFilter: {
      get() {
        return this.filter?.price_from_field_driver || []
      },
      set(val) {
        this.handleChange(val, 'field')
      },
    },
    storageFilter: {
      get() {
        return this.filter?.price_from_storage_driver || []
      },
      set(val) {
        this.handleChange(val, 'storage')
      },
    },
  },
  methods: {
    labelCheckbox(statByPrice) {
      return statByPrice.count + ' авто по ' + statByPrice.price + ' руб/кг'
    },
    handleChange(val, key) {
      const field = key === 'field' ? val : this.fieldFilter
      const storage = key === 'storage' ? val : this.storageFilter

      const priceFilters = {
        price_from_field_driver: field.length ? field : undefined,
        price_from_storage_driver: storage.length ? storage : undefined,
      }

      this.$emit('set', priceFilters)
    },
  },
}
</script>

<style lang="sass">
.filter-by-prices
  padding: 0 10px
  .row-item
    padding: 10px 0
    .el-checkbox
      margin-bottom: 5px
</style>
